export default "__VITE_ASSET__DImELjRI__"